export default {
  filters: {
    capitalizeFirstLetter(text) {
      return text[0].toUpperCase() + text.slice(1);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/utility.js